import { TWhiteLabelStore } from '../white-label.model';

export function setTopBarBg(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--topBarBg', whiteLabel.data.panelAccent);
}
